import React from "react";

export default function MarketingAutomation() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">
            MarketingAutomation
          </h2>
        </div>
      </div>
    </div>
  );
}
